import { Divider, Layout, Space, Typography } from "antd";
import React, { FC } from "react";
import Container from "@/components/container";
import { HeartFilled } from "@ant-design/icons";
import Image from "next/image";
import dayjs from "dayjs";
import icone from "public/footer-icons.png";
import logo from "public/loghi/logo-opi-bianco.png";
import styles from "./Footer.module.scss";
import Link from "next/link";
import CookieBanner from "../cookie-banner/CookieBanner";

const Footer: FC = () => {
  return (
    <div id="footer" className={styles.Wrapper}>
      <CookieBanner />
      <Layout.Footer className={styles.Footer}>
        <Container>
          <a
            target="_blank"
            rel="noreferrer"
            className={styles.Logo}
            href="https://www.opiquad.it"
          >
            <Image width={200} height={50} src={logo} alt="Opiquad" />
          </a>

          <Typography.Text className={styles.Copy}>
            <b>Opiquad S.p.A. a socio unico</b> <br />
            Via Bergamo, 60 – Merate 23807 LC <br />
            Codice Fiscale / Partita Iva 05866450967 <br />
            &copy; 2022-{dayjs(new Date()).format("YYYY")} Opiquad – Tutti i
            diritti riservati – Società soggetta a direzione e coordinamento di
            Opiquad Holding srl
          </Typography.Text>

          <Space
            wrap
            size={4}
            className={styles.Links}
            split={<Divider type="vertical" />}
          >
            <a
              target="_blank"
              rel="noreferrer"
              className={styles.SviluppoSicuro}
              href="https://www.opiquad.it/policy-di-sviluppo-sicuro/"
            >
              Policy di sviluppo sicuro
            </a>
            <Link
              className={styles.SviluppoSicuro}
              passHref
              href="/cookie-policy"
              target="_blank"
            >
              Cookie policy
            </Link>

            <Typography.Text>
              Digital R-innovation by{" "}
              <a
                title="OpiHUB"
                target="_blank"
                rel="noreferrer"
                className={styles.Hub}
                href="https://www.opiquad.it/opihub"
              >
                OpiHUB <HeartFilled />
              </a>
            </Typography.Text>
          </Space>
        </Container>

        <div className={styles.Icone}>
          <Image src={icone} alt="Icone placeholder" />
        </div>
      </Layout.Footer>
    </div>
  );
};

export default Footer;
